export default class QuestionnaireFleaAndTickStage {}

QuestionnaireFleaAndTickStage.Welcome = 'WELCOME';
QuestionnaireFleaAndTickStage.Location = 'LOCATION';
QuestionnaireFleaAndTickStage.Pet = 'PET';
QuestionnaireFleaAndTickStage.Question = 'QUESTION';
QuestionnaireFleaAndTickStage.Eligibility = 'ELIGIBILITY';

QuestionnaireFleaAndTickStage.getBaseStages = () => [
  QuestionnaireFleaAndTickStage.Welcome,
  QuestionnaireFleaAndTickStage.Location,
  QuestionnaireFleaAndTickStage.Pet,
  QuestionnaireFleaAndTickStage.Eligibility,
];
